import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ImageMagnifierService {

  openStatusChange$ = new Subject<{
    status: boolean,
    url: string
  }>();

  constructor() { }

  open(url) {
    this.openStatusChange$.next({
      status: true,
      url
    });
  }

}
